import { useEffect, useState } from "react";
import ImageProcessor from "@app/utils/ImageProcessor";

const useImageProcessor = (initialImageData, initialParams, initialAction) => {
  const [processedImageData, setProcessedImageData] = useState({ rgb: null, cmyk: null });
  const [processing, setProcessing] = useState(false);

  const removeWhiteFilters = ['removeAllWhite', 'removeWhiteBackground', 'FillColor', 'removeWhiteByIndex'];
  const restoreWhiteFilters = ['RestoreOriginalPixels', 'restoreOriginalPixelsByIndex'];

  const processImage = async (imageData, params, action) => {
    const imageProcessor = new ImageProcessor({ imageData, params, action });
    setProcessing(true);

    imageProcessor
      .setImageData(imageData)
      .setAction(action)
      .setParams(params);

    if ([...removeWhiteFilters, ...restoreWhiteFilters].includes(action)) {
      await imageProcessor.processImageData();
    }

    return {
      imageData: imageProcessor.getImageData(),
      processedPixels: imageProcessor.getProcessedPixels(),
    };
  }

  useEffect(() => {
    const { rgb: rgbImageData, cmyk: cmykImageData } = initialImageData || {};
    const noAction = !initialAction || initialAction === 'keepAllWhite';
    let cmykParams = {};

    if (!rgbImageData || !initialParams || noAction) return;

    if (restoreWhiteFilters.includes(initialAction)) {
      const { originalImageData: { rgb: originalRgbImageData, cmyk: originalCmykImageData }} = initialParams;

      cmykParams.originalImageData = originalCmykImageData;
      initialParams.originalImageData = originalRgbImageData;
    }

    processImage(rgbImageData, initialParams, initialAction).then(({ imageData: rgbImageData, processedPixels }) => {
      const isRemoveWhite = removeWhiteFilters.includes(initialAction);
      const cmykAction = isRemoveWhite ? 'removeWhiteByIndex' : 'restoreOriginalPixelsByIndex';

      cmykParams.indexData = processedPixels;
      processImage(cmykImageData, cmykParams, cmykAction).then(({ imageData: cmykImageData }) => {
        setProcessedImageData({ rgb: rgbImageData, cmyk: cmykImageData });
        setProcessing(false);
      });
    });
  }, [initialParams, initialAction]);

  return { processedImageData, processing };
}

export default useImageProcessor;